import { pipeLatLngs } from './model';

export const MAINT = { ok: '#16a34a', warn: '#eab308', defect: '#dc2626' };
export const MAINT_KEYS = ['ok', 'warn', 'defect'];
const TAG_KEY = 'giss_maint_tags';

const DEFAULTS = {
  de: { warn: ['Schwergängig', 'Straßenkappe defekt / abgesackt', 'Hinweisschild fehlt', 'Undichtigkeit / Tropft'], defect: ['Spindel überdreht', 'Lässt sich nicht schließen', 'Rohrbruch'] },
  it: { warn: ['Duro da manovrare', 'Chiusino danneggiato / ceduto', 'Cartello mancante', 'Perdita / gocciola'], defect: ['Asta spanata', 'Non si chiude', 'Rottura tubo'] },
  es: { warn: ['Duro de maniobrar', 'Tapa de registro dañada / hundida', 'Falta placa señalizadora', 'Fuga / gotea'], defect: ['Husillo pasado de rosca', 'No cierra', 'Rotura de tubería'] },
  fr: { warn: ['Dur à manœuvrer', 'Bouche à clé endommagée / affaissée', 'Plaque signalétique manquante', 'Fuite / goutte'], defect: ['Tige foirée', 'Ne se ferme pas', 'Rupture de conduite'] },
  pt: { warn: ['Difícil de manobrar', 'Tampa de caixa danificada / afundada', 'Falta placa de sinalização', 'Fuga / pinga'], defect: ['Fuso espanado', 'Não fecha', 'Rotura de conduta'] },
  sq: { warn: ['E rëndë për t’u manovruar', 'Kapaku i rrugës i dëmtuar / i ulur', 'Mungon tabela treguese', 'Rrjedh / pikon'], defect: ['Boshti i zhveshur', 'Nuk mbyllet', 'Tub i çarë'] },
  en: { warn: ['Stiff / hard to operate', 'Street cap damaged / sunk', 'Marker sign missing', 'Leaking / dripping'], defect: ['Spindle stripped', 'Cannot be closed', 'Pipe burst'] },
};

const custom = () => { try { return JSON.parse(localStorage.getItem(TAG_KEY)) || {}; } catch { return {}; } };
export const maintTags = (lang, status) => [...(DEFAULTS[lang] || DEFAULTS.de)[status] || [], ...(custom()[status] || [])];
export function addMaintTag(status, tag) {
  const c = custom();
  c[status] = [...new Set([...(c[status] || []), tag])];
  localStorage.setItem(TAG_KEY, JSON.stringify(c));
}

// new check (status click) -> patch with history (max 10)
export const maintCheck = (obj, status) => {
  const m = { status, tags: status === obj.maint?.status ? obj.maint.tags || [] : [], date: Date.now() };
  return { maint: m, maintLog: [m, ...(obj.maintLog || [])].slice(0, 10) };
};
export const maintToggleTag = (obj, tag) => {
  const tags = (obj.maint.tags || []).includes(tag) ? obj.maint.tags.filter((x) => x !== tag) : [...(obj.maint.tags || []), tag];
  const m = { ...obj.maint, tags };
  return { maint: m, maintLog: [m, ...(obj.maintLog || []).slice(1)] };
};

export const maintOf = (o) => o.maint?.status || 'none';
export const DUE_TYPES = ['valve', 'hydrant'];
export const INTERVAL_OPTIONS = [3, 6, 12, 24, 36];
const INT_KEY = 'giss_maint_intervals';
export const getIntervals = () => { try { return { valve: 12, hydrant: 12, ...JSON.parse(localStorage.getItem(INT_KEY)) }; } catch { return { valve: 12, hydrant: 12 }; } };
export const setInterval_ = (type, months) => { localStorage.setItem(INT_KEY, JSON.stringify({ ...getIntervals(), [type]: months })); window.dispatchEvent(new Event('giss-intervals')); };
// valves / hydrants never checked or last check older than the configured interval
export const isOverdue = (o) => DUE_TYPES.includes(o.type) && o.lat != null && (!o.maint || Date.now() - o.maint.date > getIntervals()[o.type] * 30.44 * 864e5);

const REP_KEY = 'giss_repairer';
export const getRepairer = () => localStorage.getItem(REP_KEY) || '';
export const maintRepair = (obj, by, note, photos = {}) => {
  localStorage.setItem(REP_KEY, by);
  const date = Date.now();
  const m = { status: 'ok', tags: [], date, repair: { by, note, date, prev: obj.maint?.status, prevTags: obj.maint?.tags || [], photos } };
  return { maint: m, maintLog: [m, ...(obj.maintLog || [])].slice(0, 10) };
};
export const objPos = (o, kind, fittings) => {
  if (kind === 'pit') return o.center || o.pts?.[0];
  if (kind === 'pipe') { const p = pipeLatLngs(o, fittings); return p[Math.floor(p.length / 2)]; }
  return o.lat != null ? [o.lat, o.lon] : null;
};
export const maintMatch = (filter, o) => !filter?.length || filter.some((k) => (k === 'due' ? isOverdue(o) : k === 'leak' ? o.type === 'leak' : k.startsWith('id:') ? o.id === k.slice(3) : maintOf(o) === k));
// all repairs with before/after photo files (ZIP/KMZ/Excel)
export const repairEntries = (project) => {
  const out = [];
  [['fitting', project.fittings || [], 'armatur'], ['pipe', project.pipes || [], 'leitung'], ['pit', project.pits || [], 'baugrube']].forEach(([kind, list, pre]) => list.forEach((o, i) => {
    (o.maintLog || []).filter((m) => m.repair).reverse().forEach((m, k) => {
      const base = `${pre}${i + 1}_reparatur${k + 1}`;
      const files = ['before', 'after'].filter((w) => m.repair.photos?.[w]).map((w) => ({ which: w, name: `${base}_${w === 'before' ? 'vorher' : 'nachher'}.jpg`, data: m.repair.photos[w].data }));
      out.push({ o, kind, m, files });
    });
  }));
  return out;
};
export const openStreetView = ([lat, lon]) => window.dispatchEvent(new CustomEvent('giss-streetview', { detail: { lat, lon } }));
export const streetViewUrl = (lat, lon) => `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lon}`;
// = target of maps.google.com/maps?layer=c&cbll=..&output=svembed (frameable, no API key)
export const streetViewEmbed = (lat, lon) => `https://www.google.com/maps/embed?origin=mfe&pb=!6m6!1m5!2m2!1d${lat}!2d${lon}!4f-0!5f1`;

// leak weight by severity, red (defect) parts 0.5
export const SEV_W = { small: 0.5, medium: 1, large: 2 };
export const SEVS = Object.keys(SEV_W);
export const damagePoints = (fittings = [], pipes = [], pits = []) => [
  ...fittings.map((o) => [o, 'fitting']), ...pipes.map((o) => [o, 'pipe']), ...pits.map((o) => [o, 'pit'])]
  .map(([o, kind]) => {
    const w = o.type === 'leak' ? (o.gl?.cls ? { A: 2, B: 1.2, C: 0.6 }[o.gl.cls] : SEV_W[o.severity] || 1)
      : o.type === 'cfault' ? 1.6 : o.type === 'gmic' ? (Number(o.gm?.int) || 0) / 50 : o.type === 'kks' && o.state === 'defect' ? 0.8
        : o.maint?.status === 'defect' ? 0.5 : 0;
    const pt = w && objPos(o, kind, fittings);
    return pt ? [pt[0], pt[1], w] : null;
  })
  .filter(Boolean);

